import { useQuery } from 'react-query';
import { GET, fetchJson } from "./http-service";
import { getEnv } from './http-service';
import { searchQuery } from 'utils';
import { appointmentJourneyStepTypeEnum, quickRescheduleJourneyStepTypeEnum, propertyTypes, linkType, rescheduleJourneyStepTypeEnum } from './hardcodedEnums';

export const Journey = ({ journeyGuid, lngCode, useMock }) => {

  const baseApi = `${lngCode}/Journeys`;
  return {
    useStepsQuery(isPreview, onSuccess) {
      return useQuery(
        ['active-query', 'steps', journeyGuid, isPreview],
        ({ queryKey }) => getSteps(...queryKey.slice(3)),
        { enabled: !!lngCode, staleTime: 1000 * 60 * 10, onSuccess: onSuccess }
      );
    },
  };

  async function getSteps(isPreview) {
    const params = {};
    if (!!isPreview) params.isPreview = isPreview;

    return GET(`${baseApi}/${journeyGuid}/journeyconfiguration`, { params })
      .then(async ({ journeyTypeId, hasRecaptcha, themeId, languages, defaultLanguage, forceDefaultLanguage, steps, journeyGUID, processGUID, clientStateData, identificationSettings, errorCode, errorMessage }) => {
        //we will get an error if the url contains processGuid when in regular journey and if it not contains processGuid when in qucik/reschedule
        sessionStorage.setItem("rcaEnabled", hasRecaptcha && !useMock ? 1 : 0);

        const [urlThemeId, urlIsPreview] = [parseInt(searchQuery('t')), searchQuery('p') === 't'];
        const appTheme = await getTheme(!!urlIsPreview && !!urlThemeId ? urlThemeId : themeId);


        return {
          languages,
          clientStateData,
          appTheme,
          identificationSettings,
          hasRecaptcha,
          journeyTypeId,
          defaultLanguage,
          forceDefaultLanguage,
          journeyGUID,
          processGUID,
          errorMessage,
          errorCode,
          steps: steps.map((step) => ({
            id: step.id,
            type: step.type,
            stepTitle: step.name,
            properties: filterAndParse(step, useMock),
            subStepList: step.subStepList.map((subStep) => filterAndParse(subStep, useMock))
          }))
        }
      });
  }

  function filterAndParse(step, useMock) {
    const properties = step.properties.reduce((properties, property) => {
      const value = JSON.parse(property.value)
      const propertyId = property.propertyId

      if (value?.isTurnOn === false) {
        return properties;
      }

      if (useMock) {
        if ([
          quickRescheduleJourneyStepTypeEnum.customerIdentification,
          appointmentJourneyStepTypeEnum.customerIdentification,
          rescheduleJourneyStepTypeEnum.customerIdentification,
          appointmentJourneyStepTypeEnum.newCustomer,
        ].includes(step.type)) {
          const { customerIdTypes, ...otherProperty } = value
          properties.push({ type: property.type, value: { ...otherProperty, customerIdTypes: customerIdTypes?.map((type, i) => ({ ...type, id: i++, regex: '' })) } })
          return properties;
        }
        if (step.type === quickRescheduleJourneyStepTypeEnum.cancellingOption
          && propertyTypes.cancelAppointment === property.type
        ) {
          const { cancelationReasonsIds, ...otherProperty } = value
          properties.push({ type: property.type, value: { ...otherProperty, cancelationReasonsIds: cancelationReasonsIds.map((_, i) => i++) } })
          return properties;
        }

      }


      if (property.type === propertyTypes.link && value.linkType !== linkType.link) {
        properties.push({ propertyId: propertyId, type: property.type, value: { ...value, executeBeforeProxy: true } })
      } else {
        properties.push({ propertyId: propertyId, type: property.type, value })
      }

      return properties;
    }, [])

    return { type: step.type, properties };
  }

  async function getTheme(themeId) {
    const { filesUrl } = await getEnv.catch((error) => { console.error(error); console.log('Can not get env.json'); });
    const [filesPath, randomVersion] = [`${filesUrl}/${themeId}`, Math.floor(Math.random() * 100000)];
    const theme = await fetchJson(`${filesPath}/FilesInfo.json?ver=${randomVersion}`);
    theme['filesUrl'] = filesUrl;

    //-----------Replace Journey.css and add BackgroundImage if exists------
    document.querySelector(`link#journey`).href = `${filesPath}/Journey.css?ver=${randomVersion}`;

    const bgElement = document.getElementById('bg_img');

    if (!!theme.BackgroundImage && bgElement && !bgElement.style.backgroundImage.includes(`${filesPath}/${theme.BackgroundImage}`)) {
        bgElement.style.backgroundImage = `url(${filesPath}/${theme.BackgroundImage}?ver=${randomVersion})`
    }
    //----------------------------------------------------------------------

    return theme;
  }
}
